import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { zip } from "../../../utils/zip";
/**
 * A note describing scatter win information.
 */
export class GameScatterWinNote extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.chanceMinText = [];
        const prizeConfig = this.model.getPrizeConfig();
        const chanceGameFeatureConfig = this.model.getFeatureConfig().getChanceGameFeatureConfig();
        const orderedChanceGameMultipliers = prizeConfig.map(prize => chanceGameFeatureConfig.getMultipliers(prize.getId())).filter(Boolean).reverse();
        const winLineFeatureConfig = this.model.getFeatureConfig().getWinLineFeatureConfig();
        const numberThreshold = winLineFeatureConfig.getThreshold(SymbolType.NUMBER);
        const jokerThreshold = winLineFeatureConfig.getThreshold(SymbolType.JOKER);
        TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        zip(this.landscapeProperties.symbolCountProperties, this.portraitProperties?.symbolCountProperties)
            .map(([landscape, portrait], i) => TitanText.createField(this, `symbol-count-${i}`, landscape, portrait))
            .reverse()
            .forEach((text, i) => {
            text.setText(`${Math.min(numberThreshold, jokerThreshold) + i + 1}`);
        });
        TitanText.createField(this, "min-title", this.landscapeProperties.minTitle, this.portraitProperties?.minTitle);
        TitanText.createField(this, "max-title", this.landscapeProperties.maxTitle, this.portraitProperties?.maxTitle);
        for (let i = 0; i < orderedChanceGameMultipliers.length; i++) {
            const text = TitanText.createField(this, `chance-min-${i + 3}`, this.landscapeProperties.minFields[i], this.portraitProperties?.minFields[i]);
            text.setText(`${orderedChanceGameMultipliers[i][0]}x`); //the first (minimum) multiplier
            this.chanceMinText.push(text);
        }
        this.chanceMaxText = TitanText.createField(this, "chance-max-field", this.landscapeProperties.maxField, this.portraitProperties?.maxField);
        const maxMultiplier = orderedChanceGameMultipliers[0][orderedChanceGameMultipliers[0].length - 1];
        this.chanceMaxText.setText(`${maxMultiplier}x`);
    }
}
//# sourceMappingURL=GameScatterWinNote.js.map